import React from 'react';

import { RecoveryPassword } from 'presentation/pages';

export const MakeRecoveryPasswordFactory: React.FC = () => {
  return <RecoveryPassword />;
};
